<template>
<div style="margin-top:200px">

     <section v-if="isShow(1)" :style="'background:url(' + require('@/assets/bg-top-right.png') +') fixed '">
          <v-row v-if="!isLoading">
               <v-col class="py-0 px-0" cols="4"></v-col>
               <v-col class="py-0 px-0" cols="4">
                    <div class="text-center mb-12">
                         <span :style="'font-weight: bold;font-size:18px; color:'+(settings[0] ? settings[0].color : '#2F839D')">{{ getName('P2S1HeadTitle') }}</span>
                         <h1 class="textSizeT">{{ getName('P2S1Title') }}</h1>
                         <div class="h-decor" :style="'background:' + (settings[0] ? settings[0].color : '#2F839D') "></div>
                    </div>
               </v-col>
               <v-col cols="3"></v-col>
               <v-col id=" hidden-sm-and-down" cols="1">
                    <v-row @click="resultRoute" class=" hand goToResult">
                         <v-col class="py-0 " cols="12" lg="7" md="7">
                              <div style="background:#fff; border-radius:50%;padding:15px" class="shadow-drop-center" size="140">
                                   <v-img style=" border-radius:30%" width="250" :src="require('@/assets/signature.gif')"></v-img>
                              </div>
                         </v-col>
                         <!-- <v-col class="py-5 hidden-s8-and-down" cols="3" lg="4" md="4">
                                        <h1 style="color: #888">{{$t('result')}}</h1>
                                        <h3 style="color: #aaa">{{$t('clickHere')}}</h3>
                                   </v-col> -->
                    </v-row>
               </v-col>
          </v-row>
          <v-row v-else>
               <v-col cols="4"></v-col>
               <v-col cols="4">
                    <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
                    <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
                    <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
               </v-col>
               <v-col cols="4"></v-col>
          </v-row>
          <div>
               <v-row>

                    <v-col v-if="!isLoading" cols="12" lg="" md="" sm="4">
                         <v-card @mouseover="hover1 = true" @mouseleave="hover1 = false" @click="changeComponent(1)" class="mx-auto text-center hand align-center" :style="hover1 ? 'transition: 0.6s;background: '+(settings[0] ? settings[0].color : '#2F839D') : 'background: #fff'" height="230" max-width="300">
                              <div class="text-center">
                                   <v-icon size="80" class=" mt-6" :color="hover1 ? '#fff' : (settings[0] ? settings[0].color : '#2F839D')">mdi-molecule</v-icon>
                              </div>
                              <v-card-title :class=" !hover1 ? 'cssTitle mb-3  mt-0 justify-center' : 'cssTitle2 mb-3  mt-0 justify-center'"><span>{{ getName('P2S1SouTitle1') }}</span></v-card-title>
                         </v-card>
                    </v-col>
                    <v-col v-else cols="12" sm="4">
                         <v-skeleton-loader ref="skeleton" type="card"></v-skeleton-loader>
                    </v-col>

                    <v-col v-if="!isLoading" cols="12" lg="" md="" sm="4">
                         <v-card @mouseover="hover2 = true" @mouseleave="hover2 = false" @click="changeComponent(2)" class="mx-auto text-center hand align-center" :style="hover2 ? 'transition: 0.6s;background: '+(settings[0] ? settings[0].color : '#2F839D') : 'background: #fff'" height="230" max-width="300">
                              <div class="text-center">
                                   <v-icon size="80" class=" mt-6" :color="hover2 ? '#fff' : (settings[0] ? settings[0].color : '#2F839D')">mdi-typewriter</v-icon>
                              </div>
                              <v-card-title :class=" !hover2 ? 'cssTitle mb-3  mt-0 justify-center' : 'cssTitle2 mb-3  mt-0 justify-center'"><span>{{ getName('P2S1SouTitle2') }}</span></v-card-title>
                         </v-card>
                    </v-col>
                    <v-col v-else cols="12" sm="4">
                         <v-skeleton-loader ref="skeleton" type="card"></v-skeleton-loader>
                    </v-col>

                    <v-col v-if="!isLoading" cols="12" lg="" md="" sm="4">
                         <v-card @mouseover="hover3 = true" @mouseleave="hover3 = false" @click="changeComponent(3)" class="mx-auto text-center hand align-center" :style="hover3 ? 'transition: 0.6s;background: '+(settings[0] ? settings[0].color : '#2F839D') : 'background: #fff'" height="230" max-width="300">
                              <div class="text-center">
                                   <v-icon size="80" class=" mt-6" :color="hover3 ? '#fff' : (settings[0] ? settings[0].color : '#2F839D')">mdi-microscope</v-icon>
                              </div>
                              <v-card-title :class=" !hover3 ? 'cssTitle mb-3  mt-0 justify-center' : 'cssTitle2 mb-3  mt-0 justify-center'"><span>{{ getName('P2S1SouTitle3') }}</span></v-card-title>
                         </v-card>
                    </v-col>
                    <v-col v-else cols="12" sm="4">
                         <v-skeleton-loader ref="skeleton" type="card"></v-skeleton-loader>
                    </v-col>

                    <v-col v-if="!isLoading" cols="12" lg="" md="" sm="4">
                         <v-card @mouseover="hover4 = true" @mouseleave="hover4 = false" @click="changeComponent(4)" class="mx-auto text-center  hand align-center" :style="hover4 ? 'transition: 0.6s;background: '+(settings[0] ? settings[0].color : '#2F839D') : 'background: #fff'" height="230" max-width="300">
                              <div class="text-center">
                                   <v-icon size="80" class=" mt-6" :color="hover4 ? '#fff' : (settings[0] ? settings[0].color : '#2F839D')">mdi-test-tube</v-icon>
                              </div>
                              <v-card-title :class=" !hover4 ? 'cssTitle mb-3  mt-0 justify-center' : 'cssTitle2 mb-3  mt-0 justify-center'"><span>{{ getName('P2S1SouTitle4') }}</span></v-card-title>
                         </v-card>
                    </v-col>

                    <v-col v-if="!isLoading" cols="12" lg="" md="" sm="4">
                         <v-card @mouseover="hover5 = true" @mouseleave="hover5 = false" @click="changeComponent(5)" class="mx-auto text-center hand align-center" :style="hover5 ? 'transition: 0.6s;background: '+(settings[0] ? settings[0].color : '#2F839D') : 'background: #fff'" height="230" max-width="300">
                              <div class="text-center">
                                   <v-icon size="80" class=" mt-6" :color="hover5 ? '#fff' : (settings[0] ? settings[0].color : '#2F839D')">mdi-hydraulic-oil-temperature</v-icon>
                              </div>
                              <v-card-title :class=" !hover5 ? 'cssTitle mb-3  mt-0 justify-center' : 'cssTitle2 mb-3  mt-0 justify-center'"><span>{{ getName('P2S1SouTitle5') }}</span></v-card-title>
                         </v-card>
                    </v-col>

               </v-row>
          </div>
     </section>

     <section v-if="isShow(2)" class="mt-12">
          <div :style="'background:url(' + require('@/assets/bg-department.png') +') fixed'">

               <v-row>
                    <v-col class="" cols="12" lg="5" md="5">
                         <v-hover v-if="!isLoading" v-slot:default="{ hover }">
                              <v-card class="mx-auto" color="grey lighten-4" max-width="100%">
                                   <v-img :src="'service/'+( checkDefault(test.img) ? checkDefault(test.img).img : '' ) | URL">
                                        <v-expand-transition>
                                             <div v-if="hover" class="d-flex transition-fast-in-fast-out grey darken-2 v-card--reveal display-3 white--text" style="height: 100%;">

                                             </div>
                                        </v-expand-transition>
                                        <template v-slot:placeholder>
                                             <v-row class="fill-height ma-0" align="center" justify="center">
                                                  <v-progress-circular indeterminate color="grey lighten-5 "></v-progress-circular>
                                             </v-row>
                                        </template>
                                   </v-img>
                              </v-card>
                         </v-hover>
                         <v-skeleton-loader v-else ref="skeleton" type="image"></v-skeleton-loader>

                    </v-col>
                    <v-col cols="12" lg="6" md="6">
                         <p v-if="!isLoading" class="textSizeST  mt-2 mx-8">{{ getName(test.title) }}</p>
                         <v-skeleton-loader v-else ref="skeleton" type="text"></v-skeleton-loader>
                         <p v-if="!isLoading" class="textSizeP2 mx-8">{{ getName(test.text) }}</p>
                         <v-skeleton-loader v-else ref="skeleton" type="paragraph"><br><br></v-skeleton-loader>
                         <!-- <p class="textSizeP mx-8">Come and experience dentistry carried out a little differently in our Private Practice. A practice where you will:</p> -->
                         <ul v-if="!isLoading">
                              <li class="textSizeP2 mx-8" v-if="getName(test.subLine1) != ''">
                                   <v-icon class="mx-3" :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-check</v-icon>{{ getName(test.subLine1) }}
                              </li>
                              <li class="textSizeP2 mx-8" v-if="getName(test.subLine2) != ''">
                                   <v-icon class="mx-3" :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-check</v-icon>{{ getName(test.subLine2) }}
                              </li>
                              <li class="textSizeP2 mx-8" v-if="getName(test.subLine3) != ''">
                                   <v-icon class="mx-3" :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-check</v-icon>{{ getName(test.subLine3) }}
                              </li>
                              <li class="textSizeP2 mx-8" v-if="getName(test.subLine4) != ''">
                                   <v-icon class="mx-3" :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-check</v-icon>{{ getName(test.subLine4) }}
                              </li>
                              <li class="textSizeP2 mx-8" v-if="getName(test.subLine5) != ''">
                                   <v-icon class="mx-3" :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-check</v-icon>{{ getName(test.subLine5) }}
                              </li>
                         </ul>
                         <ul v-else>
                              <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
                              <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
                              <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
                              <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
                              <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
                         </ul>
                    </v-col>
               </v-row>

          </div>
     </section>

     <section v-if="status[1].status == 1" :style="'background:url(' + require('@/assets/bg-top-right.png') +') fixed '" style="margin-top: 110px">
          <div class=" mb-7">
               <h1 v-if="!isLoading" class="textSizeT">{{ $t('demDevi') + ' '}}<span :style="'color:'+(settings[0] ? settings[0].color : '#2F839D')">{{ $t('devi') + ' '}}</span></h1>
               <v-skeleton-loader v-else ref="skeleton" type="text"></v-skeleton-loader>
               <div class="h-decor" :style="'background:' + (settings[0] ? settings[0].color : '#2F839D') "></div>
          </div>
          <v-row>
               <v-col v-if="!isLoading" cols="12" lg="8" md="8" sm="12">
                    <v-row style="background-color: #fff">
                         <v-col cols="10">
                              <v-text-field dense hide-details outlined v-model="form.nom" :color="(settings[0] ? settings[0].color : '#2F839D') " clearable :label="$t('vNom')" prepend-icon="mdi-account"></v-text-field>
                         </v-col>
                         <v-col cols="10" lg="5" md="5" sm="10">
                              <v-text-field dense hide-details outlined v-model="form.email" :color="(settings[0] ? settings[0].color : '#2F839D') " clearable :label="$t('email')" prepend-icon="mdi-email"></v-text-field>
                         </v-col>
                         <v-col cols="10" lg="5" md="5" sm="10">
                              <v-text-field type="number" dense hide-details outlined v-model="form.telephone" :color="(settings[0] ? settings[0].color : '#2F839D') " clearable :label="$t('phone')" prepend-icon="mdi-phone"></v-text-field>
                         </v-col>
                         <v-col cols="10">
                              <v-textarea v-model="form.message" :color="(settings[0] ? settings[0].color : '#2F839D') " :label="$t('msg')" outlined rows="8" clearable prepend-icon="mdi-message"></v-textarea>
                         </v-col>
                         <v-col @click="$refs.img.click()" class="my-1 py-0" cols="10">
                              <input type="file" ref="img" hidden @change="selectImage">
                              <v-text-field dense hide-details outlined :color="(settings[0] ? settings[0].color : '#2F839D') " :label="$t('chargImgOrd') " clearable prepend-icon="mdi-file" readonly @change="selectImage" v-model="fileExmpl"> </v-text-field>
                         </v-col>
                         <div v-if="!isLoad" class="float-right mt-8 ">
                              <v-btn class="mx-11" @click="sendToEmail('getDemandes/virifyEmail','getDemandes',1)" :color="(settings[0] ? settings[0].color : '#2F839D')" dark>
                                   <v-icon left>mdi-send</v-icon>{{ $t('send') }}
                              </v-btn>
                         </div>
                         <div v-else class="float-right mt-8 ">
                              <span class="mx-11">{{ $t('patienter') }}</span>
                         </div>
                    </v-row>
               </v-col>
               <v-col v-else cols="8">
                    <v-skeleton-loader ref="skeleton" type="list-item-avatar-three-line, image, article"></v-skeleton-loader>
               </v-col>
               <v-col v-if="!isLoading" cols="12" lg="4" md="4" sm="12">
                    <v-img max-width="100%" :src="require('@/assets/micro.png')"></v-img>
               </v-col>
               <v-col v-else cols="12" lg="4" md="4" sm="12">
                    <v-skeleton-loader ref="skeleton" type="image"></v-skeleton-loader>
               </v-col>
          </v-row>
     </section>

     <section v-if="status[3].status == 1" :style="'background:url(' + require('@/assets/bg-top-right.png') +') fixed '" style="margin-top: 140px">
          <div class=" mb-7">
               <h1 v-if="!isLoading" class="textSizeT">{{ $t('information') + ' '}}<span :style="'color:'+(settings[0] ? settings[0].color : '#2F839D')">{{ $t('patient') }}</span></h1>
               <v-skeleton-loader v-else ref="skeleton" type="text"></v-skeleton-loader>
               <div class="h-decor" :style="'background:' + (settings[0] ? settings[0].color : '#2F839D') "></div>
          </div>

          <v-btn v-if="!isLoading" @click="dialog = true" text :color="(settings[0] ? settings[0].color : '#2F839D')">
               <v-icon class="mx-3" size="20">mdi-help</v-icon>{{ $t('askQuas')  }}
          </v-btn>
          <v-skeleton-loader v-else ref="skeleton" type="text"></v-skeleton-loader>
          <div>
               <v-row>
                    <v-col v-if="!isLoading" class=" mx-auto" cols="12" lg="12" md="5">
                         <v-expansion-panels popout>
                              <v-expansion-panel v-for="(i,e) in quastion" class=" " :key="e">
                                   <v-expansion-panel-header class="py-2">
                                        <v-row>
                                             <v-col cols="12">
                                                  <div :class=" localLang == 'fr' ? 'float-left' :'float-right' ">
                                                       <v-icon class="round mx-3  " :style="'background: '+(settings[0] ? settings[0].color : '#2F839D')" color="#fff">mdi-help</v-icon>
                                                  </div>

                                                  <div class="pt-1">
                                                       <span class=" itemNav">{{e + 1}}- {{ i.question }}</span>
                                                  </div>
                                             </v-col>
                                        </v-row>
                                        <v-icon></v-icon>
                                   </v-expansion-panel-header>
                                   <v-expansion-panel-content class="textSizeP2 mx-12">
                                        <v-divider></v-divider>
                                        <span> {{ localLang == "fr" ? i.response : i.responseAr }}</span>
                                   </v-expansion-panel-content>
                              </v-expansion-panel>
                         </v-expansion-panels>
                    </v-col>
                    <v-col v-else cols="12" lg="12" md="5">
                         <v-skeleton-loader ref="skeleton" type="card-heading"></v-skeleton-loader>
                         <v-skeleton-loader ref="skeleton" type="card-heading"></v-skeleton-loader>
                         <v-skeleton-loader ref="skeleton" type="card-heading"></v-skeleton-loader>
                         <v-skeleton-loader ref="skeleton" type="card-heading"></v-skeleton-loader>
                    </v-col>
               </v-row>

          </div>
     </section>

     <v-dialog v-model="dialog" persistent max-width="320">
          <v-card>
               <v-card-title class="headline ">{{ $t('askQuas')  }}
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                         <template v-slot:activator="{ on }">
                              <v-btn v-on="on" :color="(settings[0] ? settings[0].color : '#2F839D')" outlined icon @click="dialog = false" class="mt-1 mr-2">
                                   <v-icon>mdi-close</v-icon>
                              </v-btn>
                         </template>
                         <span>{{ $t('close') }}</span>
                    </v-tooltip>
               </v-card-title>
               <v-card-text class=" px-10">

                    <v-text-field :label="$t('vNom')" v-model="form2.nom" :color="(settings[0] ? settings[0].color : '#2F839D')" append-icon="mdi-account-outline"></v-text-field>
                    <v-text-field :label="$t('vEmail')" v-model="form2.email" :color="(settings[0] ? settings[0].color : '#2F839D')" append-icon="mdi-email-outline"></v-text-field>
                    <v-text-field type="number" :label="$t('vPhone')" v-model="form2.telephone" :color="(settings[0] ? settings[0].color : '#2F839D')" append-icon="mdi-cellphone-iphone"></v-text-field>
                    <v-textarea rows="3" background-color="#fff" v-model="form2.question" :label="$t('vMsg')" :color="(settings[0] ? settings[0].color : '#2F839D')" dense append-icon="mdi-message-outline"></v-textarea>

               </v-card-text>
               <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark v-if="!isLoad2" @click="sendToEmail('getQuastion/virifyEmail','getQuastion',2)" :color="(settings[0] ? settings[0].color : '#2F839D')">{{ $t('send') }}</v-btn>
                    <span class="pa-2" v-else>{{ $t('patienter') }}</span>
               </v-card-actions>
          </v-card>
     </v-dialog>

     <v-dialog v-model="dialog22" persistent max-width="400">
          <v-card>
               <v-card-title class="headline">
                    {{ $t('checkEmailHeader') }}
                    <v-spacer></v-spacer>

                    <v-tooltip bottom>
                         <template v-slot:activator="{ on }">
                              <v-btn v-on="on" color="red" outlined icon @click="close()" class="mt-1 mr-2">
                                   <v-icon>mdi-close</v-icon>
                              </v-btn>
                         </template>
                         <span>{{ $t('close') }}</span>
                    </v-tooltip>
               </v-card-title>
               <v-card-text>
                    <p>{{ $t('textEmailVirify') }}</p>
                    <v-text-field class="mb-4" hide-details v-model="codeFromFeild" dense :label="$t('code')" outlined></v-text-field>
                    <a v-if="!dialog" @click="sendToEmail('getDemandes/virifyEmail','getDemandes',1)">{{ $t('resyee') }}</a>
                    <a v-else @click="sendToEmail('getQuastion/virifyEmail','getQuastion',2)">{{ $t('resyee') }}</a>
               </v-card-text>
               <v-card-actions v-if="dialog">
                    <v-spacer></v-spacer>
                    <v-btn :class="this.localLang == 'fr' ? 'mr-3' : 'ml-3'" v-if="!isLoad" dark :color="(settings[0] ? settings[0].color : '#2F839D')" @click=" addQuastion">{{ $t('virify') }}</v-btn>
                    <span :style="'color:'+(settings[0] ? settings[0].color : '#2F839D')" v-else>{{ $t('patienter') }}</span>

               </v-card-actions>
               <v-card-actions v-else>
                    <v-spacer></v-spacer>
                    <v-btn :class="this.localLang == 'fr' ? 'mr-3' : 'ml-3'" v-if="!isLoad" dark :color="(settings[0] ? settings[0].color : '#2F839D')" @click="sendDemande">{{ $t('virify') }}</v-btn>
                    <span :style="'color:'+(settings[0] ? settings[0].color : '#2F839D')" v-else>{{ $t('patienter') }}</span>

               </v-card-actions>
          </v-card>
     </v-dialog>
</div>
</template>

<script>
export default {

     data: () => ({
          compt: 0,
          isLoad: false,
          isLoad2: false,
          codeFromEmail: '',
          codeFromFeild: '',
          fileExmpl: '',
          dialog: false,
          dialog22: false,
          form: {},
          form2: {},
          hover1: false,
          hover2: false,
          hover3: false,
          hover4: false,
          hover5: false,
          test: {
               img: 'P2S1Img1',
               title: 'P2S1SouTitle1',
               text: 'P2S1Prag1',
               subLine1: 'P2S1Elem1',
               subLine2: 'P2S1Elem12',
               subLine3: 'P2S1Elem13',
               subLine4: 'P2S1Elem14',
               subLine5: 'P2S1Elem15',
          },
          items2: [{
                    id: 1,
                    img: 'P2S1Img1',
                    title: 'P2S1SouTitle1',
                    text: 'P2S1Prag1',
                    subLine1: 'P2S1Elem1',
                    subLine2: 'P2S1Elem12',
                    subLine3: 'P2S1Elem13',
                    subLine4: 'P2S1Elem14',
                    subLine5: 'P2S1Elem15',
               },
               {
                    id: 2,
                    img: 'P2S1Img2',
                    title: 'P2S1SouTitle2',
                    text: 'P2S1Prag2',
                    subLine1: 'P2S1Elem2',
                    subLine2: 'P2S1Elem22',
                    subLine3: 'P2S1Elem23',
                    subLine4: 'P2S1Elem24',
                    subLine5: 'P2S1Elem25',
               },
               {
                    id: 3,
                    img: 'P2S1Img3', // 
                    title: 'P2S1SouTitle3',
                    text: 'P2S1Prag3',
                    subLine1: 'P2S1Elem3',
                    subLine2: 'P2S1Elem32',
                    subLine3: 'P2S1Elem33',
                    subLine4: 'P2S1Elem34',
                    subLine5: 'P2S1Elem35',
               },
               {
                    id: 4,
                    img: 'P2S1Img4', // 
                    title: 'P2S1SouTitle4',
                    text: 'P2S1Prag4',
                    subLine1: 'P2S1Elem4',
                    subLine2: 'P2S1Elem42',
                    subLine3: 'P2S1Elem43',
                    subLine4: 'P2S1Elem44',
                    subLine5: 'P2S1Elem45',
               },
               {
                    id: 5,
                    img: 'P2S1Img5', // 
                    title: 'P2S1SouTitle5',
                    text: 'P2S1Prag5',
                    subLine1: 'P2S1Elem5',
                    subLine2: 'P2S1Elem52',
                    subLine3: 'P2S1Elem53',
                    subLine4: 'P2S1Elem54',
                    subLine5: 'P2S1Elem55',
               },
          ],
     }),
     methods: {
          close() {
               this.dialog22 = false
               this.compt = 0
          },
          resultRoute() {
               this.$router.push('resultats')
          },
          addQuastion() {
               if (this.codeFromEmail.success.match(/454E58D460212Y(.*)R44R554/)[1]  == this.codeFromFeild+"") {
                    this.isLoad2 = true
                    var url = "getQuastion/addQuastion"
                    var commit = "addQuastion"

                    this.$Register({
                         data: JSON.stringify(this.form2)
                    }, url, commit).then((r) => {
                         this.dialog = false
                         this.dialog22 = false
                         this.codeFromEmail = ""
                         this.codeFromFeild = ""
                         this.isLoad2 = false
                         this.init()
                    }, () => {
                         this.isLoad2 = false
                    })
               } else {
                    localStorage.getItem('lang') == 'fr' ? toastr.error("Ce code est faux!", "Attention") : toastr.error("هذا الرمز خاطئ!", "تحذير")
               }
          },

          init() {
               this.fileExmpl = ''
               this.form2 = {
                    type: 0,
                    nom: '',
                    email: '',
                    telephone: '',
                    question: '',
                    response: '',
                    responseAr: '',
                    domainName: document.location.origin
               }
               this.form = {
                    type: 0,
                    nom: '',
                    email: '',
                    telephone: '',
                    message: '',
                    reponse: '',
                    types: 1,
                    date_rendez_vous: '',
                    domainName: document.location.origin,
                    file: '',

               }
          },
          sendToEmail(url, commit, id) {
               if (this.compt <= 3) {
                    this.compt++
                    this.isLoad = true
                    this.isLoad2 = true
                    var url = url
                    var commit = commit

                    this.$Register({
                         data: JSON.stringify(id == 1 ? this.form : this.form2)
                    }, url, commit).then((res) => {
                         this.codeFromEmail = res
                         this.dialog22 = true
                         this.isLoad = false
                         this.isLoad2 = false
                    }).catch((err) => {
                         this.isLoad2 = false
                    })

               } else {
                    this.dialog22 = false
                    this.compt = 0
                    localStorage.getItem('lang') == 'fr' ? toastr.warning("Vérifiez l'e-mail s'il est correct", "Attention") : toastr.warning("تأكد من البريد الإلكتروني إذا كان صحيح", "تحذير")
               }
          },
          sendDemande() {
                if (this.codeFromEmail.success.match(/454E58D460212Y(.*)R44R554/)[1] == this.codeFromFeild+"") {
                    this.isLoad = true
                    var url = "getDemandes/addDemandes"
                    var commit = "getDemandes"

                    this.$Register({
                         data: JSON.stringify(this.form),
                         file: this.form.file
                    }, url, commit).then((res) => {
                         this.isLoad = false
                         this.dialog22 = false
                         this.codeFromEmail = ""
                         this.codeFromFeild = ""
                         this.init()
                    }).catch((err) => {
                         this.isLoad = false
                    })
               } else {
                    localStorage.getItem('lang') == 'fr' ? toastr.error("Ce code est faux!", "Attention") : toastr.error("هذا الرمز خاطئ!", "تحذير")
               }

          },
          selectImage(e) {
               const file = e.target.files[0]
               this.form.file = file
               this.fileExmpl = file.name
          },
          changeComponent(id) {
               let test = this.items2.find(e => e.id == id)
               this.test = test
          },
          /********************************** */
          isShow(item) {
               let array = this.$store.state.status.filter(e => e.idPage == 2)
               if (array) {
                    for (let i = 0; i < array.length; i++) {
                         if (array[i].idSection == item) {
                              return false
                         } else {
                              return true
                         }
                    }
               }
               return true
          },
          /********************************** */
          chunkArray(myArray, chunk_size) {
               var index = 0;
               var arrayLength = myArray.length;
               var tempArray = [];

               for (index = 0; index < arrayLength; index += chunk_size) {
                    let myChunk = myArray.slice(index, index + chunk_size);
                    // Do something if you want with the group
                    tempArray.push(myChunk);
               }

               return tempArray

          },
     },
     computed: {
          quastion() {
               return this.$store.state.quastion.filter(r => r.show == 1)
          },
          chunkQuastion() {
               return this.chunkArray(this.quastion, 2)
          },

     },
     created() {
          this.init()

     }
}
</script>

<style lang="scss" scoped>
.cssTitle {
     font-weight: bold;
     font-size: 20px;
     color: #555;
}

.v-expansion-panel-header {
     line-height: 1.3;
     font-size: 10px !important;
}

.cssTitle2 {
     font-weight: bold;
     font-size: 20px;
     color: #fff;
}

.testHover:hover {
     background: testHover;
}

.v-card--reveal {
     align-items: center;
     bottom: 0;
     justify-content: center;
     opacity: .5;
     position: absolute;
     width: 100%;
}

ul {
     list-style: none;
     padding: 0;
     margin: 0;
}

li::before {
     content: "  ";
     /* or whatever color you prefer */
}
</style><style>
.goToResult {
     position: fixed;
     z-index: 195656656;
}

.round {
     border-radius: 50%;
     padding: 4px;
}
</style>
